import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalActions, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import { BoltIcon, PencilIcon, TrendingUpIcon } from '@c2fo/liquidity/icons';

interface LearnMoreAboutRateOptionsModalProps {
  open: boolean;
  onClose: () => void;
}

const LearnMoreAboutRateOptionsModal = ({ open, onClose }: LearnMoreAboutRateOptionsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose} open={open} size="auto" className="max-w-[624px]">
      <ModalTitleInfo className="font-medium">{t('builder.learnMoreAboutRateOptions')}</ModalTitleInfo>
      <ModalContent>
        <div>
          <div className="grid grid-cols-[repeat(5,auto)] gap-x-4">
            <div></div>

            <div className="flex min-w-44 flex-col rounded-t-lg border border-b-0 border-primary-500 p-4 text-center">
              <div className="flex flex-col items-center">
                <BoltIcon className="size-6" />
              </div>
              <div className="mt-auto pb-4 pt-2 font-bold">{t('core.expressAccept')}</div>
              <div className="mt-auto border-t pt-4 text-sm text-text-secondary">
                {t('builder.expressAcceptDescription')}
              </div>
            </div>

            <div className="flex min-w-44 flex-col rounded-t-lg border border-b-0 border-lightBlue-500 p-4 text-center">
              <div className="flex flex-col items-center">
                <TrendingUpIcon className="size-6" />
              </div>
              <div className="mt-auto pb-4 pt-2 font-bold">{t('core.trending')}</div>
              <div className="mt-auto border-t pt-4 text-sm text-text-secondary">
                {t('builder.trendingDescription')}
              </div>
            </div>

            <div className="flex min-w-44 flex-col rounded-t-lg border border-b-0 border-gray-500 p-4 text-center">
              <div className="flex flex-col items-center">
                <PencilIcon className="size-6" />
              </div>
              <div className="mt-auto pb-4 pt-2 font-bold">{t('core.nameYourRate')}</div>
              <div className="mt-auto border-t pt-4 text-sm text-text-secondary">
                {t('builder.nameYourRateDescription')}
              </div>
            </div>
            <div className="w-2"></div>

            <div className="flex min-w-24 flex-col items-center justify-center pb-0 pt-4 text-center text-sm text-text-secondary">
              {t('builder.likelihoodOfAcceptance')}
            </div>
            <div className="flex items-center justify-center border-x border-primary-500 bg-green-50 p-4 pb-0 text-center text-sm font-medium">
              {t('builder.high')}
            </div>
            <div className="flex items-center justify-center border-x border-lightBlue-500 bg-lightBlue-50 p-4 pb-0 text-center text-sm font-medium">
              {t('builder.mediumHigh')}
            </div>
            <div className="flex items-center justify-center border-x border-gray-500 bg-gray-50 p-4 pb-0 text-center text-sm font-medium">
              {t('builder.dependsOnRateSelected')}
            </div>
            <div className="w-2"></div>

            <div className="flex min-w-24 flex-col items-center justify-center pb-0 pt-4 text-center text-sm text-text-secondary">
              {t('builder.availability')}
            </div>
            <div className="flex items-center justify-center border-x border-primary-500 bg-green-50 p-4 pb-0 text-center text-sm font-medium">
              {t('builder.dependsOnMarketAvailability')}
            </div>
            <div className="flex items-center justify-center border-x border-lightBlue-500 bg-lightBlue-50 p-4 pb-0 text-center text-sm font-medium">
              {t('builder.alwaysAvailable')}
            </div>
            <div className="flex items-center justify-center border-x border-gray-500 bg-gray-50 p-4 pb-0 text-center text-sm font-medium">
              {t('builder.alwaysAvailable')}
            </div>
            <div className="w-2"></div>

            <div className="flex items-center justify-center py-4 text-center text-sm text-text-secondary">
              {t('builder.processingTime')}
            </div>
            <div className="flex items-center justify-center rounded-b-lg border-x border-b border-primary-500 bg-green-50 p-4 text-center text-sm font-medium">
              {t('builder.instantApproval')}
            </div>
            <div className="flex items-center justify-center rounded-b-lg border-x border-b border-lightBlue-500 bg-lightBlue-50 p-4 text-center text-sm font-medium">
              {t('builder.evaluatedDuringMarketProcessing')}
            </div>
            <div className="flex items-center justify-center rounded-b-lg border-x border-b border-gray-500 bg-gray-50 p-4 text-center text-sm font-medium">
              {t('builder.evaluatedDuringMarketProcessing')}
            </div>
            <div className="w-2"></div>
          </div>
        </div>
      </ModalContent>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          {t('core.close')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default LearnMoreAboutRateOptionsModal;
